<template>
<div style="background:white">
<div class="about-page-banner">
  <div class="about-page-banner-content">We &hearts; To Innovate</div>  
</div>
<div class="mission-about">
       <div class="card" style="width:350px" data-aos="fade-up" >
        <div class="card-image">
          <img src="../assets/vision.png">
        </div>
        <div class="card-content" >
          <span class="card-title">Our Vision</span>
         <p>Our vision is to ensure that the ideas in your head get conceptualised, implemented and utilised all over the world, it becomes a reality that the world is aware of.</p>
        </div>
      </div>

         <div class="card" style="width:350px" data-aos="fade-up" >
        <div class="card-image">
          <img src="../assets/teamwork.png">
        </div>
        <div class="card-content" >
          <span class="card-title">Who we are</span>
          <p>We are an accounting firm consisting of corporate strategists, auditors, tax advisory experts, financial and market analysts.</p>
        </div>
      </div>

</div>

<div class="ecara-highlight">
    <h4>Kartik Chugh & Co.</h4>
    <p>Kartik Chugh & Co. started as professional firm of Chartered Accountants. This firm is growing and is one of professional consultancy and Audit firm rendering services to Indian and foreign clients. We enhances value for clients by focusing on solutions that are innovative, yet practical and that can be implemented. 
We, at believe in giving highly personalized and customized services to our clients, keeping intact the best of industry standards with lowest possible turn around time.
Our experienced team brings on board a hands-on experience and a practical approach to each business situation by understanding the client’s objectives and identifying potential issues from a strategic as well as tactical perspective..</p>
</div>

<div class="container service-expectation">
    <div class="skill-set">
    <h4>Approach</h4>
    <p>To provide continued excellent standards of professionalism with the highest quality service within pre-specified time limits.  To Build trust and relationship is paramount in all our actions. We firmly believe that integrity has no substitute. 
    <br><br>Top end quality of our client deliverables is a commitment we have made to ourselves and we travel the extra mile to achieve it. Every assignment at  our firm is under the direct charge of an engagement partner whose responsibility is to be a mentor, guide and supervisor to the engagement team.
    <br><br>For us, “ Nothing is impossible” is more than a slogan - it reflects our approach to every engagement
    </p>
</div>

<div class="ecara-highlight">
    <h4>Our Firms Structure</h4>
    <h6>How we work together?</h6>
    <p>We pride ourselves in maintaining high standards of professional servicing both in terms of quality and timely delivery. Furthermore our engagement team is encouraged to be innovative and  research oriented. Team  members are not only hard working but are intelligent working professionals.  Each assignment becomes the responsibility of a partner who is assisted by a manager and his team. As and when, any client assignment requires a more holistic approach, all service vertical teams are well trained and equipped to collaborate and provide all aspects of advisory to a particular situation.</p>
</div>

  </div>
</div>
</template>

<script>
export default {
  name: "About",
  props: {
  },
  data(){
      return{
      
      }
  },
   mounted(){
  },
  methods:{
   
  }
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat");
div{
    font-family: 'Montserrat', sans-serif;
}
p{
  text-align:justify;
}
.about-page-banner{
  background-image:linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url("../assets/about.jpg");
  height: 40vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  margin-top:-20px;
}
.about-page-banner-content{
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-transform: uppercase;
  font-size: 2em;
  font-weight: 700;
}
.ecara-highlight{
  padding:4% 15%;
  margin:5% 0px;
  background: #efefef;
  text-align:center;
}

.card-title{
  position:relative !important;
  font-weight: 600 !important;
  font-size:18px !important;
}
.card{
  text-align:center;
  margin:20px;
  border:0px;
  box-shadow:0px 0px 0px;
}
.card-content p{
  text-align:center;
}
.mission-about{
  display:flex;
  flex-wrap: wrap;
  align-items:center;
  justify-content: center;
}
.service-expectation{
  padding:2% 0px 5% 0px;
}
.service-offered{
  margin-bottom:10%;
}
h4{
  font-size:24px;
  font-weight:600;
  margin-bottom:20px;
}
.card-image img{
  width:25% !important;
  margin:auto !important;
  padding:5px !important;
}

</style>